import { LoginResult } from "models/login.model";


export const loginReducer = (state: LoginResult, action: { type: string; value: LoginResult; }) => {
    switch (action.type) {
        case 'set': return action.value;
        default: throw new Error('Unexpected action');
    }
};